import React from 'react';
import { Field } from 'formik';

import styles from './compensationSubmissionFormStyles.scss';
import CompensationFormButtons from './CompensationFormButtons/compensationFormButtons';

import dollarSignInputField from 'buyside/components/presentation/Form/Field/InputField/addonFirstInputField';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';

import { formatCompensations } from 'buyside/util/formatNumber';
const {
  fundSizes,
  fundTypeNames,
  compFundStrategy,
  compIndustry,
  assetClassNames,
  compTitle,
  yearOfExp,
  cities
} = require('buyside/util/constantsFromRails.json');

class CompensationSubmissionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { posPrefill: false, compPrefill: false };
    this.renderPosPrefillCheckbox = this.renderPosPrefillCheckbox.bind(this);
    this.renderCompPrefillCheckbox = this.renderCompPrefillCheckbox.bind(this);
    this.renderOptionalFieldMessage = this.renderOptionalFieldMessage.bind(this);
    this.togglePositionFields = this.togglePositionFields.bind(this);
    this.toggleCompensationFields = this.toggleCompensationFields.bind(this);
    this.computeTotalCashCompensation = this.computeTotalCashCompensation.bind(this);
    this.computeTotalCashDeferredCompensation = this.computeTotalCashDeferredCompensation.bind(
      this
    );
    this.promptCommentsForLowIncome = this.promptCommentsForLowIncome.bind(this);
  }

  renderPosPrefillCheckbox() {
    const { category, mode } = this.props.values;
    if (category === 'estimated' && mode === 'new') {
      return (
        <label>
          <input
            type="checkbox"
            defaultChecked={this.state.posPrefill}
            onChange={this.togglePositionFields}
            className={styles.chckbox}
          />
          Check this box if your position has not changed from last year to this year.
        </label>
      );
    }
  }

  renderCompPrefillCheckbox() {
    const { category, mode } = this.props.values;
    if (category === 'estimated' && mode === 'new') {
      return (
        <label>
          <input
            type="checkbox"
            defaultChecked={this.state.compPrefill}
            onChange={this.toggleCompensationFields}
            className={styles.chckbox}
          />
          Check this box if your compensation has not changed from last year to this year.
        </label>
      );
    }
  }

  renderOptionalFieldMessage() {
    const { mode } = this.props.values;
    if (mode === 'new') {
      return (
        <span className={styles.optionalFields}>
          <strong>Optional</strong> - if left blank, these fields are assumed to be '0' (zero).
        </span>
      );
    }
  }

  togglePositionFields() {
    this.setState({ posPrefill: !this.state.posPrefill }, () => {
      const { values, setFieldValue } = this.props;
      if (this.state.posPrefill === true) {
        setFieldValue('title', values.actualComp.title);
        setFieldValue('experience', values.actualComp.experience);
        setFieldValue('industry', values.actualComp.industry);
        setFieldValue('location', values.actualComp.location);
        setFieldValue('fundType', values.actualComp.fundType);
        setFieldValue('fundStrategy', values.actualComp.fundStrategy);
        setFieldValue('fundSize', values.actualComp.fundSize);
        setFieldValue('assetClass', values.actualComp.assetClass);
      } else {
        setFieldValue('title', '');
        setFieldValue('experience', '');
        setFieldValue('industry', '');
        setFieldValue('location', '');
        setFieldValue('fundType', '');
        setFieldValue('fundStrategy', '');
        setFieldValue('fundSize', '');
        setFieldValue('assetClass', '');
      }
    });
  }

  toggleCompensationFields() {
    this.setState({ compPrefill: !this.state.compPrefill }, () => {
      const { values, setFieldValue } = this.props;
      if (this.state.compPrefill === true) {
        setFieldValue('baseSalary', values.actualComp.baseSalary);
        setFieldValue('interestMgmtFeesPerc', values.actualComp.interestMgmtFeesPerc);
        setFieldValue('interestMgmtFeesValue', values.actualComp.interestMgmtFeesValue);
        setFieldValue('vestingMgmtFees', values.actualComp.vestingMgmtFees);
        setFieldValue('interestIncentiveFeesPerc', values.actualComp.interestIncentiveFeesPerc);
        setFieldValue('interestIncentiveFeesValue', values.actualComp.interestIncentiveFeesValue);
        setFieldValue('vestingIncentiveFees', values.actualComp.vestingIncentiveFees);
        setFieldValue('annualDiscrBonus', values.actualComp.annualDiscrBonus);
        setFieldValue('totalDeferredComp', values.actualComp.totalDeferredComp);
      } else {
        setFieldValue('baseSalary', '');
        setFieldValue('interestMgmtFeesPerc', '');
        setFieldValue('interestMgmtFeesValue', '');
        setFieldValue('vestingMgmtFees', '');
        setFieldValue('interestIncentiveFeesPerc', '');
        setFieldValue('interestIncentiveFeesValue', '');
        setFieldValue('vestingIncentiveFees', '');
        setFieldValue('annualDiscrBonus', '');
        setFieldValue('totalDeferredComp', '');
      }
    });
  }

  computeTotalCashCompensation() {
    const totalCashCompFields = [
      'baseSalary',
      'annualDiscrBonus',
      'interestIncentiveFeesValue',
      'interestMgmtFeesValue'
    ];
    return totalCashCompFields
      .map(field => Number(this.props.values[field]))
      .reduce((a, b) => a + b);
  }

  computeTotalCashDeferredCompensation() {
    const totalCash = this.computeTotalCashCompensation();
    return totalCash + Number(this.props.values['totalDeferredComp']);
  }

  promptCommentsForLowIncome() {
    this.props.touched.baseSalary &&
    this.props.touched.annualDiscrBonus &&
    this.computeTotalCashCompensation() < 60000 ? (
      <div className={styles.lowIncomeMsg}>
        The income you are entering is abnormal based on site-wide stats. Please explain the
        circumstances of your income situation.
      </div>
    ) : (
      ''
    );
  }

  render() {
    const { values, isSubmitting, setFieldValue } = this.props;
    const {
      title,
      experience,
      industry,
      location,
      fundType,
      fundStrategy,
      fundSize,
      assetClass,
      baseSalary,
      interestMgmtFeesPerc,
      interestMgmtFeesValue,
      vestingMgmtFees,
      interestIncentiveFeesPerc,
      interestIncentiveFeesValue,
      vestingIncentiveFees,
      annualDiscrBonus,
      totalDeferredComp,
      investInFund,
      buildPersonalTrackRecord,
      marketPersonalTrackRecord,
      comments
    } = this.props.values;
    const checkboxText = {
      investInFund: 'I am able to invest in the fund without paying fees.',
      buildPersonalTrackRecord:
        'This firm allows me to build a personal track record through managing a book or sub-portfolio.',
      marketPersonalTrackRecord:
        'This firm allows me to market my personal track record post-employment.'
    };
    const placeholder = 'Please select...';
    const city = cities.map(location => location.name);

    return (
      <form onSubmit={this.props.handleSubmit} className={styles.formContainer}>
        <h4 className={styles.subHeading}>Your Role</h4>
        {this.renderPosPrefillCheckbox()}
        <Field
          component={InputField}
          name="title"
          type="select"
          label="Role"
          options={compTitle}
          value={title}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="experience"
          type="select"
          label="Years of Experience"
          options={yearOfExp}
          value={experience}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="industry"
          type="select"
          label="Industry"
          options={compIndustry}
          value={industry}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="location"
          type="select"
          label="Location"
          options={city}
          value={location}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="fundType"
          type="select"
          label="Firm Type"
          options={fundTypeNames}
          value={fundType}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="fundStrategy"
          type="select"
          label="Fund Strategy"
          options={compFundStrategy}
          value={fundStrategy}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="fundSize"
          type="select"
          label="Fund Size"
          options={fundSizes}
          value={fundSize}
          placeholder={placeholder}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="assetClass"
          type="select"
          label="Asset Class Expertise"
          options={assetClassNames}
          value={assetClass}
          placeholder={placeholder}
          customStyles={styles}
        />

        <h4 className={styles.subHeading}>Compensation</h4>
        {this.renderCompPrefillCheckbox()}
        <Field
          component={dollarSignInputField}
          name="baseSalary"
          addon="$"
          label="Base Salary"
          value={baseSalary}
          customStyles={styles}
          note="*Note:
            If you only worked for part of the year, please annualize these numbers."
        />
        <h4 className={styles.subHeading}>Portion of Management Fees Collected Annually</h4>
        {this.renderOptionalFieldMessage()}
        <Field
          component={InputField}
          name="interestMgmtFeesPerc"
          addon="%"
          label="Percentage"
          value={interestMgmtFeesPerc}
          customStyles={styles}
        />
        <Field
          component={dollarSignInputField}
          name="interestMgmtFeesValue"
          addon="$"
          label="Cash"
          value={interestMgmtFeesValue}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="vestingMgmtFees"
          addon="years"
          label="Vesting Period"
          value={vestingMgmtFees}
          customStyles={styles}
        />
        <h4 className={styles.subHeading}>Portion of Incentive Fees Collected Annually</h4>
        {this.renderOptionalFieldMessage()}
        <Field
          component={InputField}
          name="interestIncentiveFeesPerc"
          addon="%"
          label="Percentage"
          value={interestIncentiveFeesPerc}
          customStyles={styles}
        />
        <Field
          component={dollarSignInputField}
          name="interestIncentiveFeesValue"
          addon="$"
          label="Cash"
          value={interestIncentiveFeesValue}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="vestingIncentiveFees"
          addon="years"
          label="Vesting Period"
          value={vestingIncentiveFees}
          customStyles={styles}
        />
        <h4 className={styles.subHeading}>Other Bonuses</h4>
        {this.renderOptionalFieldMessage()}
        <div className={styles.totalCompContainer}>
          <Field
            component={dollarSignInputField}
            name="annualDiscrBonus"
            addon="$"
            label="Other Cash Bonus"
            value={annualDiscrBonus}
            customStyles={styles}
          />
          <div className={styles.innerCompContainer}>
            <span className={styles.compLabel}>Total Cash Compensation: </span>
            <span className={styles.compNum}>
              {formatCompensations(this.computeTotalCashCompensation())}
            </span>
          </div>
        </div>
        <div className={styles.totalCompContainer}>
          <Field
            component={dollarSignInputField}
            name="totalDeferredComp"
            addon="$"
            label="Total Deferred Compensation"
            value={totalDeferredComp}
            customStyles={styles}
          />
          <div className={styles.innerCompContainer}>
            <span className={styles.compLabel}>Total Cash + Deferred Compensation: </span>
            <span className={styles.compNum}>
              {formatCompensations(this.computeTotalCashDeferredCompensation())}
            </span>
          </div>
        </div>
        {this.promptCommentsForLowIncome()}
        <Field
          component={SingleCheckboxField}
          name="investInFund"
          type="checkbox"
          label={checkboxText.investInFund}
          value={investInFund}
          customStyles={styles}
        />
        <Field
          component={SingleCheckboxField}
          name="buildPersonalTrackRecord"
          type="checkbox"
          label={checkboxText.buildPersonalTrackRecord}
          value={buildPersonalTrackRecord}
          customStyles={styles}
        />
        <Field
          component={SingleCheckboxField}
          name="marketPersonalTrackRecord"
          type="checkbox"
          label={checkboxText.marketPersonalTrackRecord}
          value={marketPersonalTrackRecord}
          customStyles={styles}
        />
        <Field
          component={InputField}
          name="comments"
          type="textarea"
          label="Compensation Structure (Optional)"
          placeholder="Include any additional information
          regarding the firm's compensation structure here."
          value={comments}
          customStyles={styles}
        />
        <CompensationFormButtons
          values={values}
          isSubmitting={isSubmitting}
          setFieldValue={setFieldValue}
        />
      </form>
    );
  }
}

export default CompensationSubmissionForm;
